import qs from 'qs';
import clientConfig from '../../clientConfig';
import { ClientConfig } from '../../types';

export function getPingIdentityLogoutUrl(
  location?: Pick<Location, 'origin' | 'pathname'>,
): string {
  const pingIdentityAuth = (clientConfig as ClientConfig).pingIdentityAuth;

  if (!pingIdentityAuth?.enabled || !location) {
    return '';
  }

  const { origin, pathname } = location;
  const { logoutHost } = pingIdentityAuth;

  if (!logoutHost) {
    return '';
  }

  const queryParams = qs.stringify(
    {
      goto: `${origin}${pathname}`,
    },
    {
      addQueryPrefix: true,
    },
  );

  return `${logoutHost}${queryParams}#logout`;
}
